<template>
  <div class="px-4 py-3 space-y-6 max-w-6xl">
    <!-- Nom, prénom, email, téléphone, adresse -->
    <div class="flex items-center justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm">Nom</label>
      <input
        type="text"
        v-model="lastName"
        placeholder="Entrez votre nom"
        class="w-2/3 max-w-xl border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>
    <div class="flex items-center justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm">Prénom</label>
      <input
        type="text"
        v-model="firstName"
        placeholder="Entrez votre prénom"
        class="w-2/3 max-w-xl border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>
    <div class="flex items-center justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm">Email</label>
      <input
        type="email"
        v-model="email"
        placeholder="Entrez votre email"
        class="w-2/3 max-w-xl border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>
    <div class="flex items-center justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm">Téléphone</label>
      <input
        type="text"
        v-model="telephone"
        placeholder="Entrez votre numéro"
        class="w-2/3 max-w-xl border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>
    <div class="flex items-center justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm">Adresse</label>
      <input
        type="text"
        v-model="adresse"
        placeholder="Entrez votre adresse"
        class="w-2/3 max-w-xl border border-gray-200 rounded-lg px-3 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>
    <hr />

    <!-- Photo de profil -->
    <div class="flex items-center justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm">Photo de profil</label>
      <div class="w-2/3 flex items-center gap-4">
        <div class="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden shadow-sm">
          <img v-if="profilePhotoUrl" :src="profilePhotoUrl" alt="Photo de profil" class="w-full h-full object-cover" />
          <span v-else class="text-gray-400 text-xl">👤</span>
        </div>
        <label class="cursor-pointer bg-gray-100 px-4 py-2 rounded shadow-sm text-sm hover:bg-gray-200 transition">
          Choisir
          <input type="file" class="hidden" @change="handleProfileUpload" />
        </label>
      </div>
    </div>
    <hr />

    <!-- Supprimer le compte -->
    <div class="flex items-center justify-between">
      <label class="w-1/3 text-gray-600 font-medium text-sm">Supprimer le compte</label>
      <button @click="deleteAccount" class="w-2/3 max-w-xs bg-red-500 text-white px-6 py-2 rounded text-sm hover:bg-red-600 transition">
        Supprimer mon compte
      </button>
    </div>

    <!-- Bouton de sauvegarde -->
    <div class="flex justify-end pt-4">
      <button
        @click="saveProfileSettings"
        class="bg-blue-500 text-white px-6 py-2 rounded text-sm hover:bg-blue-600 transition"
      >
        Sauvegarder
      </button>
    </div>
  </div>
</template>

<script>
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

export default {
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      telephone: '',
      adresse: '',
      profilePhoto: null,
      profilePhotoUrl: null,
    };
  },
  methods: {
    handleProfileUpload(event) {
      this.profilePhoto = event.target.files[0];
      this.profilePhotoUrl = URL.createObjectURL(this.profilePhoto);
    },
    async saveProfileSettings() {
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Vous devez être connecté");

        const formData = new FormData();
        formData.append("nom", this.lastName);
        formData.append("prenom", this.firstName);
        formData.append("email", this.email);
        formData.append("telephone", this.telephone);
        formData.append("adresse", this.adresse);
        if (this.profilePhoto) formData.append("photo", this.profilePhoto);

        const res = await fetch("https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/profile", {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Erreur lors de la mise à jour");

        localStorage.setItem("token", data.token || token);
        toast.success("Profil mis à jour avec succès !");
      } catch (error) {
        console.error(error);
        toast.error("Erreur : " + error.message);
      }
    },
    deleteAccount() {
      if (confirm("Voulez-vous vraiment supprimer votre compte ? Cette action est irréversible.")) {
        console.log("Compte supprimé");
        toast.success("Compte supprimé !");
      }
    },
  },
  async mounted() {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const res = await fetch("https://datafuseweb-95a5588f8542.herokuapp.com/api/clients/profile", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (res.ok) {
        this.firstName = data.prenom || '';
        this.lastName = data.nom || '';
        this.email = data.email || '';
        this.telephone = data.telephone || '';
        this.adresse = data.adresse || '';
        this.profilePhotoUrl = data.photo || null;
      }
    } catch (err) {
      console.error(err);
      toast.error("Impossible de charger le profil");
    }
  },
};
</script>

<style scoped>
hr {
  border-color: #e5e7eb;
}
</style>
